module.exports = __webpack_public_path__ + "static/media/patterns-infograpic.36b08007.svg";